import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";

export const Wrapper = styled.div`
    padding-top: 68px;
    padding-bottom: 2rem;
    background-color: #f1f1f1;
    min-height: 100vh;
`;

export const TitleWrapper = styled.div`
    height: 150px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: #2f283d;
    font-size: 30px;
    font-weight: 700;
`;

export const JobListWrapper = styled.div`
    grid-template-areas:
        "header"
        "main";
    grid-template-rows: auto 80dvh;
    grid-template-columns: 1fr;
    grid-row-gap: 7rem;
    width: 80% !important;
    background: var(--b-wf-9-f-9-f-9, #f9f9f9);

    @media (${theme.breakpoints.tabletL}) {
        padding: 0 2rem;
    }

    @media (${theme.breakpoints.mobileL}) {
        grid-template-areas:
            "main"
            "sidenav";
        grid-template-rows: auto 1fr;
        grid-template-columns: none;

        grid-row-gap: 2rem;
        padding: 0 2rem;
    }
`;
export const HeaderText = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 0.3rem;
`;
export const CountsWrapper = styled.div`
    ${theme.mixins.flexCenter};

    .resultsText {
        margin-left: 0.3rem;
    }
`;
export const CardsColumn = styled.div`
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow-y: scroll;
    height: 66dvh;
    padding-right: 1rem;
`;

export const JobListItem = styled.div`
    padding: 16px;
    background-color: #fff;
    border-radius: 16px;
    min-height: 140px;
    min-width: 800px;
`;

export const JobTitle = styled.p`
    font-size: 20px;
    line-height: 24px;
    color: ${theme.colors.text};
    font-weight: 600;
`;

export const GreyText = styled.div`
    font-size: 12px;
    font-weight: 500;
    color: #cecbd2;
    line-height: 14px;
`;

export const IconRow = styled.div`
    display: flex;
    gap: 2rem;
    align-items: center;
    margin-top: 2rem;
    svg {
        color: #00bbc7;
        margin-right: 6px;
    }
`;

export const MiddleRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Icon = styled.div`
    display: flex;
    align-items: center;
`;

export const ItalicText = styled.div`
    font-size: 12px;
    line-height: 14px;
    font-style: italic;
    color: #cecbd2;
    font-weight: 500;
`;

export const BottomRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2rem;
`;

export const CountText = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${theme.colors.text};
`;
export const RightSection = styled.div`
    grid-area: main;
    border-radius: 24px;
    position: relative;
    height: 100%;
    background-color: ${theme.colors.white};
    padding: 16px 14px;
    /* overflow-y: scroll; */

    @media (${theme.breakpoints.mobileL}) {
    }
`;
export const AgencyImage = styled.img`
    width: 26px;
    height: 26px;
    border-radius: 50%;
    margin-right: 5px;
`;

export const CardRight = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: space-between;
    align-items: flex-end;

    svg:first-of-type {
        cursor: pointer;
        font-size: 16px;
    }
`;
export const HorizontalCard = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 160px;
    padding: 10px;
    background-color: #fff;
    border-radius: 20px;
    gap: 17px;
    position: relative;
`;

export const CardLeft = styled.div`
    height: 100%;
`;

export const CardImage = styled.img`
    width: 140px;
    height: 140px;
    border-radius: 16px;
`;

export const CardContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;
export const CardChip = styled(Text)`
    padding: 4px 10px;
    border-radius: 20px;
    color: #fff;
    font-weight: 500;
    font-size: 11px;
    background-color: #ffbb0d;
`;

export const Info = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    svg {
        color: #00bbc7;
        font-size: 18px;
    }
    ${Text.Style} {
        margin-top: 1px;
    }
`;

export const Posted = styled(Text)`
    font-style: italic;
`;
export const CardTitle = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
`;
export const NoDataContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 10px;
    padding-bottom: 40px;
    flex-wrap: wrap;
    background-color: white;
    margin-top: -11px;
    border-radius: 20px;
    align-items: center;
`;
export const NoDataContentCenter = styled.div`
    position: absolute; /* Absolute positioning within RightSection */
    top: 50%; /* Position at the vertical center */
    left: 50%; /* Position at the horizontal center */
    transform: translate(-50%, -50%); /* Center the element exactly */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 20px;
    border-radius: 20px;
    text-align: center;
    background-color: white; /* Optional, adjust as needed */
`;
